import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceListComponent } from './invoice-list/invoice-list.component';
import { InvoiceService } from './shared/services/invoice.service';
import { InvoiceLookupResolveService } from './shared/services/invoice-lookup-resolve.service';
import { InvoiceShellComponent } from './invoice-shell/invoice-shell.component';
import { invoicesRoutingModule } from './invoices-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { SendInvoiceDialogComponent } from './send-invoice-dialog/send-invoice-dialog.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ListboxModule } from 'primeng/listbox';

@NgModule({
  imports: [
    CommonModule,
    invoicesRoutingModule,
    SharedModule,
    ListboxModule,
    CheckboxModule,
  ],
  providers: [InvoiceService, InvoiceLookupResolveService],
  declarations: [
    InvoiceListComponent,
    InvoiceShellComponent,
    SendInvoiceDialogComponent,
  ],
})
export class InvoicesModule {}
